import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiClient from "../../config/AppAdmin";

export const fetchWaiterData = createAsyncThunk(
  "waiter/fetchWaiterData",  // Changed from "menu/fetchWaiterData" to "waiter/fetchWaiterData"
  async () => {
    const response = await ApiClient.get(`/rider`);
    console.log("response",response.data);
    if (response.data) {
      return response.data; // Return the data array
    }
    throw new Error("Invalid data format");
  }
);

const waiterSlice = createSlice({
  name: "rider",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaiterData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWaiterData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchWaiterData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default waiterSlice.reducer;